function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-141.021 -27)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-1083.594-317.4l-9.862-6.614,9.862-10.791,9.746,10.791Z",
  transform: "translate(1236 371)",
  fill: "none",
  stroke: "#181923",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M-1083.652-334.8v17.288",
  transform: "translate(1236 371)",
  fill: "none",
  stroke: "#181923",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("text", {
  transform: "translate(171 51)",
  fill: "#181923",
  fontSize: 22,
  fontFamily: "SegoeUI, Segoe UI"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "directADS")));

var SvgDark = function SvgDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logoDark34",
    width: 126.979,
    height: 30,
    viewBox: "0 0 126.979 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dark.a3de8ac4.svg";
export { ForwardRef as ReactComponent };